module.exports = __webpack_public_path__ + "img/pulse-iot-center.c6101573.png";